import React, {useState} from "react";
import assets from "../assets/imgs";
import {useUser} from "../context/UserContext";

const dateBoxBaseHeight = 140;
const dateBoxPaddingTop = 16;
const dateBoxPaddingBottom = 10;
const dateBoxGap = 8;
const dateTitleHeight = 27;
const dateBoxContentsHeight = dateBoxPaddingTop + dateTitleHeight + dateBoxGap + dateBoxPaddingBottom;
const eventBoxHeight = 28;
const eventBoxGap = 4;

function BoardCalendar({style, currentMonth, handlePrevMonth, handleNextMonth, data, handlePlanAdd, handlePlanClick}) {
  // const [currentDate, setCurrentDate] = useState(new Date());
  const {authority} = useUser();

  let calendarStartDate = null;
  let calendarEndDate = null;

  const getMonthDays = (year, month) => {
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const daysInPrevMonth = new Date(year, month, 0).getDate(); // 이전 달의 마지막 날
    const lastDayOfMonth = new Date(year, month, daysInMonth).getDay(); // 마지막 날의 요일

    const days = [];
    // 이전 달의 빈 칸
    for (let i = firstDay - 1; i >= 0; i--) {
      const prevMonth = month === 0 ? 11 : month - 1;
      const prevYear = month === 0 ? year - 1 : year;
      days.push({ 
        day: daysInPrevMonth - i, 
        month: prevMonth, 
        year: prevYear,
        currentMonth: false, 
      });
      // days.push({ day: daysInPrevMonth - i, currentMonth: false });
    }
    // 현재 달의 날짜
    for (let i = 1; i <= daysInMonth; i++) {
      days.push({ 
        day: i, 
        month: month, 
        year: year,
        currentMonth: true, 
      });
    }
    // 다음 달 날짜 채우기 (마지막 요일 기준으로 필요한 칸만 채움)
    for (let i = 1; i < 7 - lastDayOfMonth; i++) {
      const nextMonth = month === 11 ? 0 : month + 1;
      const nextYear = month === 11 ? year + 1 : year;
      days.push({ 
        day: i, 
        month: nextMonth, 
        year: nextYear,
        currentMonth: false, 
      });
    }

    return days;
  };

  const krToday =new Date(new Date().toLocaleString("ko-KR", {timeZone: "Asia/Seoul"}));

  // const checkResult = [
  //   { date: new Date("2025-02-03"), complete: 2 , doing: 1},
  //   { date: new Date("2025-02-10"), complete: 2 , doing: 0},
  //   { date: new Date("2025-02-15"), complete: 1 , doing: 1},
  // ];


  // const handlePrevMonth = () => {
  //   const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
  //   setCurrentDate(prevMonth);
  // };

  // const handleNextMonth = () => {
  //   const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  //   setCurrentDate(nextMonth);
  // };
  const dummyMonth = new Date(currentMonth);

  const year = dummyMonth.getFullYear();
  const month = dummyMonth.getMonth();
  const days = getMonthDays(year, month);
  // console.log('days:', days);
  if(days.length > 0){
    const firstDay = days[0];
    const lastDay = days[days.length - 1];

    calendarStartDate = new Date(firstDay.year, firstDay.month, firstDay.day);
    calendarEndDate = new Date(lastDay.year, lastDay.month, lastDay.day);
  }

  // 날짜별 이벤트 배치 정보 저장
  const eventPositions = {};
  const sortedEvents = [...data].sort((a, b) => new Date(a.start_date) - new Date(b.start_date));

  return (
    <div className="commonComponent" style={{...style, padding: "20px", margin: "16px"}}>
      {/* 상단 네비게이션 */}
      <div style={styles.calendarHead}>
        <div style={styles.calendarHeadCenter}>
          <button style={styles.calendarHeadButton} onClick={handlePrevMonth}>
            <assets.icons.chevron_left style={{ color: "var(--grayscale-cool_100)"}}/>
          </button>
          <div style={styles.titleSection}>
            <img src={assets.icons.calendar} style={{width: "20px"}}/>
            <p style={styles.calendarTitle}>{year}.{String(month + 1).padStart(2, "0")}</p>
          </div>
          <button style={styles.calendarHeadButton} onClick={handleNextMonth}>
            <assets.icons.chevron_right style={{ color: "var(--grayscale-cool_100)"}}/>
          </button>
        </div>
        {(authority >= 5) && (
          <div style={styles.btnAdd} className="font-body2-semibold" onClick={handlePlanAdd}>
            일정 추가
          </div>  
        )}
      </div>
      {/* 요일 */}
      <div style={styles.calendarContents}>
        <div style={styles.calendarDayTop}>
          {["일", "월", "화", "수", "목", "금", "토"].map((day) => (
            <div key={day} className="font-body3-semibold" style={{...styles.dayName,
              color: day === "토" ? "#376DFF" : day === "일" ? "#FF6258" : "#676767"
            }}>
              {day}
            </div>
          ))}
        </div>
        {/* 날짜 */}
        <div style={styles.calendarDay}>
          {days.map((item, index) => {
            const currentDate = new Date(item.year, item.month, item.day);

            // 해당 날짜에 포함된 이벤트 찾기
            const matchedEvents = sortedEvents.filter((event) => {
              const startDate = new Date(`${event.start_date}T00:00:00`);
              const endDate = new Date(`${event.end_date}T00:00:00`);
              return currentDate >= startDate && currentDate <= endDate;
            });

            // 이벤트별 높이 설정
            const occupiedPositions = new Set();
            const eventStyles = {};
            let maxTopPosition = 0;

            matchedEvents.forEach((event) => {
              if (eventPositions[event._id] === undefined) {
                let topPosition = 0; // 기본 시작 높이
                while (occupiedPositions.has(topPosition)) {
                  topPosition += (eventBoxHeight + eventBoxGap); // 28 + 4px 간격으로 배치
                }
                eventPositions[event._id] = topPosition;
              }              
              
              // console.log('eventPositions : ', eventPositions);
              // console.log('occupied Positions: ', occupiedPositions);
              occupiedPositions.add(eventPositions[event._id]);
              eventStyles[event._id] = { top: `${eventPositions[event._id]}px` };

              //최대 position 계산
              maxTopPosition = Math.max(maxTopPosition, eventPositions[event._id]);
            });

            const maxAllowedHeight = dateBoxBaseHeight - dateBoxContentsHeight; // 기본 eventSection의 최대 높이
            const newHeight = ((maxTopPosition + eventBoxHeight) > maxAllowedHeight) 
              ? (maxTopPosition + eventBoxHeight + dateBoxContentsHeight) 
              : dateBoxBaseHeight;

            // 오늘 날짜인지 확인
            const isToday =
             currentDate.getFullYear() === krToday.getFullYear() &&
             currentDate.getMonth() === krToday.getMonth() &&
             currentDate.getDate() === krToday.getDate();

            return (
              <div key={index} className="font-body1-bold"
                style={{...styles.dateBox, height: `${newHeight}px`}}
              >
                <p style={{...styles.dateTitle, 
                  ...(item.currentMonth ? {} : styles.falseDateTitle),
                  ...(isToday ? styles.todayDate : {})}}>
                  {item.day}</p>
                {/* 이벤트 표시 */}
                <div style={styles.eventSection}>
                  {matchedEvents.map((event) => {
                    const eventStartDate = new Date(`${event.start_date}T00:00:00`);
                    const eventEndDate = new Date(`${event.end_date}T00:00:00`);
                    const currentTime = currentDate.getTime();

                    const startDate = eventStartDate < calendarStartDate ? calendarStartDate : eventStartDate;
                    const endDate = eventEndDate > calendarEndDate ? calendarEndDate : eventEndDate;

                    const totalDays = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
          
                    const middleIndex = Math.floor(totalDays / 2);
                    const middleDate = new Date(startDate);
                    middleDate.setDate(startDate.getDate() + middleIndex);

                    const isMiddleDate = currentTime === middleDate.getTime();

                    // // 🔹 중간 날짜인지 확인 (타이틀을 표시할지 여부)
                    // const isMiddleDate = currentDate > startDate && currentDate < endDate;
                    // const isStartDate = currentDate.getTime() === startDate.getTime();
                    // const isEndDate = currentDate.getTime() === endDate.getTime();
                    // const isSingleDate = isStartDate && isEndDate;

                    return(
                      <div key={event._id} className="font-body3-medium" 
                        style={{ ...styles.eventBox, backgroundColor: getEventColor(event._id), ...eventStyles[event._id] }}
                        onClick={() =>{handlePlanClick(event._id)}}>
                        {isMiddleDate ? event.title : ""}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// 이벤트 별 색상 부여
const getEventColor = (id) => {
  const colors = ["#FF9999", "#99CCFF", "#99FF99", "#FFCC99"];
  return colors[id % colors.length];
};

const commonPoint ={
  width: "10px",
  height: "10px",
  borderRadius: "50%",
}

const styles ={
  calendarHead:{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "22px 0px",
    // height: "51px",
    boxSizing: "border-box",
    height: "72px",
    borderBottom: "1px solid var(--grayscale-cool_20)",
    marginBottom: "24px",
    position: "relative",
  },
  calendarHeadCenter:{
    display: "flex",
    // flex: "1",
    justifyContent: "center",
    alignItems: "center",
    gap: "44px",
    // height: "51px",
    boxSizing: "border-box",
  },
  btnAdd:{
    position: "absolute",
    right: "16px", top: "12px",
    width: "150px", height: "48px",
    borderRadius: "8px", border: "1px solid var(--primary-crimson_60)",
    display:"flex", alignItems: "center", justifyContent: "center",
    color: "var(--primary-crimson_60)",
    cursor: "pointer"
  },
  titleSection:{
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  calendarTitle:{
    fontWeight: "600",
    fontSize: "18px",
    lineHeight:"27px",
    color: "var(--text-color_90)",
    borderRadius: "20px 20px 0px 0px",
  },
  calendarHeadButton:{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "20px",
    height: "20px",
    cursor: "pointer",
    borderRadius: "50%",
    backgroundColor: "#F3F3F8",
    padding: "0",
    border: "0px",
  },
  calendarContents:{
  },
  calendarDayTop:{
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    textAlign: "center",
    backgroundColor: "var(--grayscale_20)",
    borderRadius: "12px 12px 0xp 0px"
  },
  calendarDay:{
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    textAlign: "center",
  },
  dayName :{
    // width: "94px",
    height: "45px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dateBox:{
    border: "1px solid var(--grayscale_30)",
    // width: "94px",
    display: "flex",
    flexDirection : "column",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: `${dateBoxGap}px`,
    padding: `${dateBoxPaddingTop}px 0px ${dateBoxPaddingBottom}px 0px`,
    boxSizing: "border-box",
  },
  dateTitle:{
    width: "35px",
    height: `${dateTitleHeight}px`,
    textAlign:"center",
    color: "#676767",
    display: "flex",
    justifyContent:"center",
    alignItems: "center"
  },
  todayDate:{
    backgroundColor: "var(--grayscale_30)",
    color: "var(--grayscale_90)",
    borderRadius: "50%",
  },
  falseDateTitle:{
    color: "var(--text-color_30)",
  },
  emptyDate: {
    backgroundColor: "transparent",
    color: "transparent",
    pointerEvents: "none",
  },
  eventSection: {
    position: "relative",
    width: "100%",
  },
  eventBox: {
    position: "absolute",
    width: "100%",
    display: "flex",
    height: "28px",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    textAlign: "center",
    cursor: "pointer"
  }
  // checkPointSection:{
  //   display:"flex",
  //   gap:"8px"
  // },
  // checkPoint:{
  //   ...commonPoint,
  //   backgroundColor: "var(--primary-crimson_60)",
  // },
  // doingPoint:{
  //   ...commonPoint,
  //   backgroundColor: "var(--grayscale-cool_40)",
  // }

}

export default BoardCalendar;